<i18n>
{
  "fr": {
    "sorry-error": "Désolé, une erreur s'est produite",
    "req-not-found": "Page demandée non trouvée !",
    "take-me-home": "Retour à l'accueil"
  },
  "en": {
    "sorry-error": "Sorry, an error has occured",
    "req-not-found": "Requested page not found!",
    "take-me-home": "Take me home"
  }
}
</i18n>

<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container" style="margin-top:-60px">
        <div class="columns is-vcentered">
          <div class="column is-6 mt-50">
            <img style="box-shadow: 0 2px 29px 0 rgba(68, 88, 144, 0.12);"
                 src="@/assets/notfound.jpg"/>
          </div>
          <div class="column is-6 has-text-centered">
            <p style="font-size: 26px;font-weight: 300;font-family: 'Poppins', sans-serif;color: #2a2c39;">
              {{ $t('sorry-error') }}
              <br/>
              {{ $t('req-not-found') }}
              <br/><br/>
            </p>
            <button
              class="button is-primary"
              @click="$router.push('/')"
              type="submit"
            >
              <span class="icon is-small"><i class="fa fa-home"></i></span>
              <span>{{ $t('take-me-home') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
